(function () {
  'use strict';

  /* Les surfaces concernees : les CARTES, le titre H1 de la fiche produit et la
     barre d'achat collante. Volontairement absents — le panier lateral
     (.ai-cd-item-title-*) et la page /cart (.cart-item__name) : au moment de
     payer, le client doit relire le nom entier de ce qu'il achete. */
  var CIBLES = [
    '[class*="ai-pgrid-title-"]:not([class*="ai-pgrid-title-link"])',
    /* Carrousel de l'accueil. La cible historique visait __product-title, une
       classe qui n'existe sur aucune page : mesure du 16 sept. 2026 en 375px,
       0 element trouve. Le vrai nom est __product-link, porte par le <a> — et
       il y en a 16 sur l'accueil, tous a 0 enfant, tous avec le type en clair
       (« Iced Out Cross Bracelet », « 3mm Tennis Chain », « GOAT Iced Out
       Pendant »). C'etait la source principale du « je vois encore ring et
       necklace » : la grille etait traitee, le carrousel non. L'ancienne cible
       est conservee au cas ou une section plus ancienne la porte encore. */
    '[class*="ai-split-carousel__product-title"]',
    '[class*="ai-split-carousel__product-link-"]',
    /* Bloc de vente croisee de la fiche produit et de l'accueil : <p> a 0
       enfant, verifie en direct le 16 sept. 2026 (« Miami Cuban Link Chain »).
       Derniere surface ou le type restait visible sur mobile.

       A NE PAS ajouter ici : ai-shop-category-card-title-* et
       ai-category-card-title-*. Ce sont des noms de COLLECTION (« Chains »,
       « Earrings », « Rings ») : le mot de type EST le nom de la carte, la
       masquer laisserait une case vide. Verifie le meme jour, 8 cartes. */
    '[class*="ai-cu-name-"]',
    '[class*="ai-search-card-"] .title',
    /* [href*="/products/"] est indispensable : la classe .card__heading de Dawn
       sert AUSSI aux cartes de collection (snippets/card-collection.liquid) et
       aux cartes d'article de blog (snippets/article-card.liquid). Sans ce
       filtre, une collection "Boucles d'oreilles" s'affichait "D'oreilles" et un
       article "How to Clean Your Chain" perdait son dernier mot. Les URL de
       produit contiennent toujours /products/, y compris en /fr/ ; celles des
       collections (/collections/) et des articles (/blogs/) jamais. */
    '.card__heading a[href*="/products/"]',
    /* Fiche produit. On vise h1.product-title, pas .product-title tout court :
       seul le H1 porte le nom du produit de la page, et il n'a aucun enfant
       (verifie en direct), donc le decoupage s'applique sans risque. Comme
       partout ailleurs, le mot n'est masque qu'en dessous de 749px — sur
       ordinateur le titre reste entier. */
    'h1.product-title',
    /* Barre d'achat collante de la fiche produit. Meme raison que le H1 : elle
       reprend le nom du produit de la page et n'a aucun enfant (verifie en
       direct le 16 sept. 2026). Sans elle, « Pendant », « Chain » ou « Bague »
       restaient affiches en bas de l'ecran alors que le titre juste au-dessus
       ne les affichait deja plus. Comme partout, le mot n'est masque qu'en
       dessous de 749px : sur ordinateur le titre reste entier. */
    '.fl-sticky-atc__title'
  ].join(',');

  /* Anglais : le type ferme le titre ("2mm Tennis Chain", "... Chain for Men").
     Francais : le type ouvre le titre ("Bracelet trefle", "Chaine corde").
     Les accents sont ecrits en echappements \u00xx : la regex ne depend donc
     d'aucun encodage de fichier. */
  var TYPES_EN = 'Chain|Bracelet|Ring|Necklace|Earrings|Pendant';
  var EN_QUEUE = new RegExp('(\\s+)(' + TYPES_EN + ')\\b(?![\\s\\S]*\\b(?:' + TYPES_EN + ')\\b)');
  /* "Boucles" et "Puces" ne sont le type qu'accompagnes de "d'oreilles" : le
     groupe optionnel avale les deux mots d'un coup, sinon un futur produit
     "Boucles d'oreilles creoles" se serait affiche "D'oreilles creoles". */
  var FR_TETE = new RegExp(
    '^(Bracelet|Cha\\u00eene|Collier|Bague|Pendentif|Puces|Boucles|Anneau|Chevali\\u00e8re)' +
    '((?:\\s+d[\'\\u2019\\u02bc]oreilles)?\\s+)'
  );

  /* Garde-fou anti-contresens : si le titre restant contient encore un AUTRE mot
     de type, on ne masque rien. Sans lui, "Sleek Snake Chain Bracelet" (un
     bracelet, product_type bracelet) s'affichait "Sleek Snake Chain" — un
     bracelet vendu sous le nom d'une chaine. Au Canada c'est une representation
     trompeuse, pas seulement une maladresse.
     Comparaison mot a mot, accents retires : "Ringlet" ou "Chainmail" ne
     declenchent donc rien, contrairement a une recherche de sous-chaine. */
  /* Suffixe de genre, toujours en fin de titre : « ... for Men », « ... for
     Women », « ... pour homme », « ... pour femme ». Traite separement du type
     et sur TOUTES les largeurs d'ecran. Le \s*$ ancre la recherche a la fin :
     un futur produit « Gift for Women Set » ne serait pas touche. */
  var GENRE = new RegExp(
    '(\\s+)(for\\s+(?:Men|Women)|pour\\s+(?:homme|femme)s?)\\s*$', 'i');

  var MOTS_TYPE = ['chain', 'bracelet', 'ring', 'necklace', 'earrings', 'pendant',
    'chaine', 'collier', 'bague', 'pendentif', 'puces', 'boucles', 'anneau', 'chevaliere'];
  function contientUnType(txt) {
    var t = txt.toLowerCase();
    if (t.normalize) { t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    var mots = t.split(/[^a-z0-9]+/);
    for (var i = 0; i < mots.length; i++) {
      if (MOTS_TYPE.indexOf(mots[i]) !== -1) { return true; }
    }
    return false;
  }

  function decoupe(el) {
    if (!el || !el.querySelector) { return; }
    /* Deja fait. C'est le seul drapeau : pas d'attribut memorise, car plusieurs
       sections REECRIVENT le titre apres coup (el.textContent = ...). Un drapeau
       pose une fois aurait fige l'etat et laisse ces titres non coupes — c'est
       exactement le defaut mesure sur 2 cartes de la page best-sellers. */
    if (el.querySelector('.fl-mot-type') || el.querySelector('.fl-mot-genre')) { return; }
    /* Titre fait d'un seul morceau de texte uniquement : s'il porte deja des
       elements (badge, texte pour lecteur d'ecran), on n'y touche pas.
       Exception (8 oct. 2026) : les <span class="fl-nt"> que fl-notranslate pose
       autour des noms de design (« Iced Out », « Miami Cuban ») ne comptent pas.
       Le titre est recoupe a partir de son texte, et fl-notranslate les repose
       aussitot. Sans elle, une carte chargee tard gardait son mot de type
       visible sur mobile si fl-notranslate passait en premier. */
    for (var c = 0; c < el.children.length; c++) {
      if (!el.children[c].classList.contains('fl-nt')) { return; }
    }
    var brut = (el.textContent || '').trim();
    if (!brut) { return; }

    /* Le suffixe de genre se detache EN PREMIER, avant toute recherche de type :
       il est masque a toutes les largeurs, y compris quand le type, lui, reste
       affiche (sur ordinateur, ou quand le garde-fou anti-contresens bloque). */
    var genre = '';
    var g = brut.match(GENRE);
    if (g) { genre = g[0]; brut = brut.slice(0, g.index); }

    var m = brut.match(FR_TETE);
    var avant = '', mot = '', apres = '', premiereLettre = '';

    if (m) {
      mot = m[1] + m[2];
      apres = brut.slice(m[0].length);
      premiereLettre = apres.slice(0, 1);
      apres = apres.slice(1);
    } else {
      m = brut.match(EN_QUEUE);
      if (m) {
        avant = brut.slice(0, m.index);
        mot = m[0];
        apres = brut.slice(m.index + m[0].length);
      }
    }

    /* Contresens possible : on n'enleve le type que si plus aucun autre type ne
       subsiste. Le suffixe de genre, lui, part dans tous les cas — « for Men »
       ne peut pas transformer un bracelet en chaine. */
    if (mot && contientUnType(avant + ' ' + premiereLettre + apres)) {
      mot = ''; apres = ''; premiereLettre = '';
    }
    /* Rien a masquer du tout : on laisse le titre intact. */
    if (!mot && !genre) { return; }
    if (!mot) { avant = brut; }

    var frag = document.createDocumentFragment();
    if (avant) { frag.appendChild(document.createTextNode(avant)); }
    if (mot) {
      var span = document.createElement('span');
      span.className = 'fl-mot-type';
      span.textContent = mot;
      frag.appendChild(span);
    }
    if (premiereLettre) {
      var maj = document.createElement('span');
      maj.className = 'fl-maj';
      maj.textContent = premiereLettre;
      frag.appendChild(maj);
    }
    if (apres) { frag.appendChild(document.createTextNode(apres)); }
    if (genre) {
      var gspan = document.createElement('span');
      gspan.className = 'fl-mot-genre';
      gspan.textContent = genre;
      frag.appendChild(gspan);
    }

    el.textContent = '';
    el.appendChild(frag);
  }

  function passe(racine) {
    try {
      var n = racine || document;
      if (n.nodeType === 3) { n = n.parentElement; }
      if (!n || !n.querySelectorAll) { return; }
      if (n.matches && n.matches(CIBLES)) { decoupe(n); }
      var trouves = n.querySelectorAll(CIBLES);
      for (var i = 0; i < trouves.length; i++) { decoupe(trouves[i]); }
      /* Le titre peut etre AU-DESSUS du noeud ajoute (une section qui remplace
         seulement le texte interieur). On remonte donc au titre parent. */
      if (n.closest) {
        var parent = n.closest(CIBLES);
        if (parent) { decoupe(parent); }
      }
    } catch (e) { /* ne jamais bloquer l'affichage pour un titre */ }
  }

  function demarre() {
    passe(document);
    if (!window.MutationObserver) { return; }
    var enAttente = [];
    var prevu = false;
    function planifie() {
      if (prevu) { return; }
      prevu = true;
      /* rAF appele via window : detache, il leve "Illegal invocation".
         Onglet en arriere-plan : le navigateur gele requestAnimationFrame. Un
         client qui ouvre le site dans un onglet d'arriere-plan verrait alors
         les titres entiers jusqu'a ce qu'il y revienne. On repasse donc sur
         setTimeout des que la page est masquee. */
      var tick = (window.requestAnimationFrame && !document.hidden)
        ? function (f) { window.requestAnimationFrame(f); }
        : function (f) { setTimeout(f, 16); };
      tick(function () {
        prevu = false;
        var lot = enAttente.splice(0, enAttente.length);
        for (var k = 0; k < lot.length; k++) { passe(lot[k]); }
      });
    }
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mu = mutations[i];
        /* characterData : une section qui ecrit el.textContent = "..." ne cree
           qu'un noeud TEXTE. C'est ce cas qui laissait 2 cartes non coupees. */
        if (mu.type === 'characterData') {
          /* Le compte a rebours et le compteur de visiteurs reecrivent du texte
             plusieurs fois par seconde. Sans ce filtre, chacune de leurs
             ecritures replanifiait une passe pour rien. */
          var pt = mu.target.parentElement;
          if (pt && pt.closest && pt.closest(CIBLES)) { enAttente.push(mu.target); }
          continue;
        }
        for (var j = 0; j < mu.addedNodes.length; j++) {
          var nd = mu.addedNodes[j];
          if (nd.nodeType === 1 || nd.nodeType === 3) { enAttente.push(nd); }
        }
      }
      if (enAttente.length) { planifie(); }
    }).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true
    });
    /* Deux filets de securite : les sections qui peuplent leurs cartes tard
       (carrousels, recommandations) sont ainsi rattrapees meme si l'observateur
       a manque leur ecriture. Les passes sont sans effet sur ce qui est deja fait. */
    window.addEventListener('load', function () { passe(document); });
    setTimeout(function () { passe(document); }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarre);
  } else {
    demarre();
  }
})();
